import { connect } from 'react-redux'
import UI from './UI'
import { selectTagForCategory } from '../store'
import { ProfileTypes } from 'constants/'

const mapStateToProps = ({ catalog, user, referential }) => ({
  tags: catalog.tags,
  selectedTag: catalog.selectedTag,
  selectedCategory: catalog.selectedCategory,
  loading: catalog.loadingTags,
  profileType: user?.ProfileType ? ProfileTypes[referential?.ProfileTypes[user.ProfileType]] : null
})

const mapDispatchToProps = (dispatch) => ({
  handleTagClick: (tag) => dispatch(selectTagForCategory(tag))
})

export default connect(mapStateToProps, mapDispatchToProps)(UI)
